<template>
  <div id="cert_online_check_view" v-if="judgeData != null">
    <div v-if="judgeData.status == 4" class="notice-label">{{notice1}}</div>
    <div v-else class="notice-label">{{(notice2 != null && notice2 != '') ? notice2 : errDefaultNotice}}</div>
    <el-button v-if="judgeData.status != 4" class="cancel-button" @click="backToEditInfor" round>返回修改</el-button>
  </div>
</template>

<script>
export default {
  name: "CertApplicationOfficialCheckVue",
  props: {
    judge: {
      default: () => null,
    }
  },
  data() {
    return {
      notice1: '您的身份认证信息正在复核，预计5个工作日内完成。',
      notice2: '上传照片与需认证信息不符，请重新上传后提交',
      errDefaultNotice: '上传照片与需认证信息不符，请重新上传后提交',
      judgeData: null,
    }
  },
  mounted() {
    this.judgeData = this.judge;
    this.notice2 = this.judgeData.auditRemark;
  },
  methods: {
    backToEditInfor() {
      //....
      //发送信息修改请求
      //返回信息编辑页
      this.$emit("backToEditPage");
    }
  }
}
</script>

<style scoped>
  #cert_online_check_view {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 300px;
  }

  #cert_online_check_view .cancel-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 90%;
    max-width: 300px;
    padding-left: 0;
    padding-right: 0;
    color: white;
    margin-bottom: 15px;
  }

  #cert_online_check_view .notice-label {
    height: 50vh;
    max-height: 170px;
    vertical-align: middle;
    display: flex;
    align-items: center;
    /*background-color: yellow;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationOfficialCheckVue.vue